<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               label-width="85px"
               :rules="rfmrules"
               ref="rfmForm"
               style="width: 100%">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="type"
                          label="报表">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择报表类型"
                         @change="changeType"
                         style="width: 100%">
                <el-option v-for="(item,idx) of type_list"
                           :key="idx"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择行业"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择商家"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择店铺"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type==13">
          <el-col :span="6"
                  v-if="form.type==13">
            <el-form-item label="商品类型">
              <el-input v-model="form.prdType"
                        clearable
                        placeholder="请输入商品类型"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="一级分类">
              <el-input v-model="form.category1"
                        clearable
                        placeholder="请输入一级分类"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="form.type==13">
            <el-form-item label="二级分类">
              <el-input v-model="form.category2"
                        clearable
                        placeholder="请输入二级分类"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="SKU">
              <el-input v-model="form.skuCode"
                        clearable
                        placeholder="请输入单个SKU"
                        oninput="value=value.replace(/[^\w\u4E00-\u9FA5]/g, '')"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>

          <el-col :span="6"
                  v-if="form.type !=12">
            <el-form-item prop="time"
                          label="日期"
                          :rules="[
                            { 
                              type:'array',
                              required: true,
                              message: '请选择日期',
                              fields:{ 
                                0:{type:'string',required: true,message: '请选择日期',},
                                1:{type:'string',required: true,message: '请选择日期',}
                                },trigger: 'blur'},]">

              <el-date-picker v-model="form.time"
                              type="monthrange"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="form.type==12">
            <el-form-item prop="timeA"
                          label="时间段A"
                          :rules="[
                            { 
                              type:'array',
                              required: true,
                              message: '请选择时间段A',
                              fields:{ 
                                0:{type:'string',required: true,message: '请选择时间段A',},
                                1:{type:'string',required: true,message: '请选择时间段A',}
                                },trigger: 'blur'},]">
              <el-date-picker v-model="form.timeA"
                              type="monthrange"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="form.type==12">
            <el-form-item prop="timeB"
                          label="时间段B"
                          :rules="[
                            { 
                              type:'array',
                              required: true,
                              message: '请选择时间段B',
                              fields:{ 
                                0:{type:'string',required: true,message: '请选择时间段B',},
                                1:{type:'string',required: true,message: '请选择时间段B',}
                                },trigger: 'blur'},]">

              <el-date-picker v-model="form.timeB"
                              type="monthrange"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6"
                  v-if="form.type==5">
            <el-form-item prop="create_time"
                          label="日期">

              <el-date-picker v-model="form.time"
                              type="month"
                              placeholder="选择月"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col> -->

          <el-col :span="6"
                  v-if="form.type==5">
            <el-form-item prop="interval"
                          :rules="[
      { required: true, message: '请选择范围',trigger: 'change' }]"
                          label="范围">
              <el-select clearable
                         v-model="form.interval"
                         placeholder="请选择范围..."
                         style="width: 100%">
                <el-option v-for="item in [{'name':'3个月','value':3},{'name':'6个月','value':6},{'name':'12个月','value':12}]"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注">
              <el-input v-model="form.remark"
                        clearable
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <!-- <el-row type="flex"
                justify="center"
                v-if="showContent">
          <el-col :span="12">
            <div v-html="content"
                 class="show-content">
            </div>
          </el-col>
        </el-row> -->
      </el-form>
    </el-card>

    <el-card class="button-box">
      <el-row>
        <el-col>
          <el-button type="primary"
                     :loading="loading"
                     @click="handleClick">导出</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- <el-card class="box-card">
      <div slot="header"
           class="clearfix">
        <span>系统说明</span>
        <el-button style="float: right; padding: 3px 0"
                   type="text">操作按钮</el-button>
      </div>
      <div v-html="content"
           class="show-content">
      </div>
    </el-card> -->
    <el-card v-if="form.type">

      <el-row type="flex"
              justify="center">
        <el-card v-if="showContent"
                 style=" width: 90%;">

          <div slot="header"
               class="show-content">
            <div style="text-align: center; ">
              <span >{{type_name}}报表说明</span>
              <span style="float: center;   display: block;  margin-top: 10px;font-size: 14px;">{{contentList.created_at | parseTime }}
              </span>

            </div>

          </div>
          <!-- <el-divider></el-divider> -->
          <div v-html="content"
               class="show-content">
          </div>

          <!-- <el-col :span="12">
          <div v-html="content"
               class="show-content">
          </div>
        </el-col> -->

        </el-card>
        <div style="font-size: 14px;color: #606266;"
             v-if="showNone">
          暂无说明
        </div>
      </el-row>
    </el-card>
    <!-- <el-card v-if="showNone">
      <el-row type="flex"
              justify="center">
        <el-col :sm="12"
                :lg="6">
          <div>
            <p>暂无说明</p>
          </div>
        </el-col>
      </el-row>
    </el-card> -->
  </div>
</template>

<script>
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
const tempPrefixeUrl = 'http://test.databankapi.transecs.com/'
export default {
  mixins: [getplatlists, getptnlists, getshoplists, gettradefrom],
  data() {
    return {
      form: {
        type: '',
        profession: '',
        store: '',
        business: '',
        time: '',
        remark: '',
        timeA: [],
        timeB: [],
        interval: '',
        prdType: '',
        category1: '',
        category2: '',
        skuCode: '',
      },
      dialogData: this.form,
      loading: false,
      tableData: [],
      type_name: '',
      msg: '',
      Desc,
      content: '',
      contentList: [],
      showContent: false,
      showNone: false,
      reportTypeList: [],
      'label-width': '90px',
      type_list: [
        { name: '销售额单月', value: 1 },
        { name: '顾客继续新规', value: 2 },
        { name: '顾客Recency&运转率', value: 3 },
        { name: '顾客F×M累计', value: 4 },
        { name: '顾客level报表', value: 5 },
        { name: '顾客继续-既存', value: 6 },
        { name: '顾客继续-整体', value: 7 },
        { name: '销售额移动和', value: 8 },
        { name: '顾客存活', value: 9 },
        { name: '顾客FM累计-12个月', value: 10 },
        { name: '商品-新客', value: 11 },
        { name: '商品-交叉营销', value: 12 },
        { name: '商品-继续', value: 13 },
      ],
      rfmrules: {
        type: [{ required: true, message: '请选择报表类型', trigger: 'blur' }],
        profession: [
          { required: true, message: '请选择行业', trigger: 'blur' },
        ],
        business: [{ required: true, message: '请选择商家', trigger: 'blur' }],
        store: [{ required: true, message: '请选择店铺', trigger: 'blur' }],
      },
    }
  },
  created() {
    // this.getTableData();
    // this.getOperatelogReporttype()
  },
  methods: {
    changeType(value) {
      this.type_list.forEach((v) => {
        if (v.value == value) {
          this.type_name = v.name
        }
      })
      console.log('aaa:', value)
      this.form.remark = ''
      this.form.time = []
      this.form.timeA = []
      this.form.timeB = []
      this.form.prdType = ''
      this.form.category1 = ''
      this.form.category2 = ''
      this.form.skuCode = ''
      if (this.form.type != 5) {
        console.log('change')

        if (this.form.interval) {
          this.form.interval = ''
        }
      } else {
        this.form.time = []
      }
      this.getExportDesc()
    },
    async getExportDesc() {
      if (!this.form.type) {
        return
      }
      this.showContent = false
      this.content = ''

      let { data, err } = await this.axiosApi(Desc.get_export_desc, {
        type: this.form.type,
      })
      // console.log('data', data.data.data)
      // console.log('error', err)

      // console.log(JSON.parse(data.data.data[0]))
      if (data && data.data && data.data.data) {
        // console.log("data", data)
        this.content = data.data.data.desc
        this.contentList.created_at = data.data.data.created_at
        this.contentList.created_user = data.data.data.created_user
        this.contentList.updated_at = data.data.data.updated_at
        this.contentList.deupdated_usersc = data.data.data.updated_user

        this.showContent = true
        this.showNone = false
      } else {
        this.showContent = false
        this.showNone = true
      }
      // dealReturn(data, err)
      this.loading = false
    },
    resetForm() {
      this.form = {
        type: '',
        interval: '',
        profession: '',
        store: '',
        business: '',
        time: '',
        remark: '',
        timeB: [],
        timeA: [],
        prdType: '',
        category1: '',
        category2: '',
        skuCode: '',
      }
    },
    handleClick() {
      let isValid
      this.$refs.rfmForm.validate((valid) => {
        isValid = valid
      })
      console.log('isValid', isValid)
      if (!isValid) {
        return
      }

      if (this.form.type == 12) {
        if (!this.form.timeA) {
          this.$message.error('请选择时间段A')
          return
        }
        if (!this.form.timeB) {
          this.$message.error('请选择时间段B')
          return
        }
      }
      if (this.form.type == 5) {
        if (!this.form.interval) {
          this.$message.error('请选择范围')
          return
        }
      }
      if (!this.form.type) {
        this.$message.error('请选择报表类型')
        return
      }

      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      if (this.form.type != 12) {
        if (!this.form.time) {
          this.$message.error('请选择时间')
          return
        }
      }

      var formData = {
        type: this.form.type,
        profession: this.form.profession,
        store: this.form.store,
        business: this.form.business,
        remark: this.form.remark,
      }

      if (this.form.type == 12) {
        ;(formData.timeA = this.form.timeA), (formData.timeB = this.form.timeB)
      } else {
        formData.time = this.form.time
      }

      if (this.form.type == 5) {
        formData.interval = this.form.interval
      }

      if (this.form.type == 13) {
        formData.skuCode = this.form.skuCode
        formData.category1 = this.form.category1
        formData.category2 = this.form.category2
        formData.prdType = this.form.prdType
      }
      this.rfmReport(formData)
    },

    async rfmReport(formData) {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.rfm_api, formData)
      console.log('data', data)
      this.loading = false
      if (data && data.data.meta.status == 200) {
        this.$alert('导出成功，请稍后在导出日志查看', '导出成功', {
          confirmButtonText: '确定',
          type: 'success',
        })
      }
      dealReturn(data, err)
    },
  },
}
</script>

<style lang="scss" scoped>
.show-content{
  // font-size: 14px;
  color: #606266;
  padding: 0;
  margin-top: 1px;
  // border-radius: 4px;
  // width: 60%;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

</style>



// WEBPACK FOOTER //
// src/views/rfm/rfmexport/index.vue